module.exports = __webpack_public_path__ + "media/images/keyVisual_pc_zh-hans-a41179bd77460b8bf2d18c312cc7c9b1.jpg";